import React, { useEffect, useState } from "react";
import { Bell, X, Mail, ArrowLeftRight } from "lucide-react";
import {
  Badge,
  Dropdown,
  List,
  Typography,
  Avatar,
  Empty,
  Tooltip,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatMessageTime } from "../utils/formatMessageTime";
import {
  getNotifications,
  readNotification,
} from "../actionCreator/commonActionCreator";
import { markAsRead } from "../actionCreator/leadDetailsActionCreator";

const emailTemplates = [
  "You’ve received an email from {{name}}.",
  "New email from {{name}}.",
  "{{name}} sent you an email.",
  "Incoming message from {{name}}.",
  "Message received from {{name}}.",
];

const replyTemplates = [
  "{{name}} replied to your email.",
  "You’ve got a reply from {{name}}.",
  "{{name}} has responded to your message.",
  "Reply received from {{name}}.",
  "{{name}} just replied to your email.",
];

const getRandomEmailMessage = (name) => {
  const index = Math.floor(Math.random() * emailTemplates.length);
  return emailTemplates[index].replace("{{name}}", name);
};

const getRandomReplyMessage = (name) => {
  const index = Math.floor(Math.random() * replyTemplates.length);
  return replyTemplates[index].replace("{{name}}", name);
};
const NotificationDropdown = ({ isAuthLayout }) => {
  const dispatch = useDispatch();
  const [viewAll, setViewAll] = useState(false);
  const unreadNotifications = useSelector(
    (state) => state.LeadDetailsReducer.unreadNotifications,
  );
  const notifications = useSelector(
    (state) => state.CommonReducer.notifications,
  );

  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  return (
    <Dropdown
      dropdownRender={() => (
        <div className="notification-dropdown">
          <div className="notification-header">Notifications</div>
          {unreadNotifications?.length || notifications?.length ? (
            <>
              <List
                itemLayout="horizontal"
                dataSource={
                  viewAll
                    ? [...unreadNotifications, ...notifications].sort(
                        (a, b) =>
                          new Date(b.createdDate) - new Date(a.createdDate),
                      )
                    : [...unreadNotifications, ...notifications]
                        .sort(
                          (a, b) =>
                            new Date(b.createdDate) - new Date(a.createdDate),
                        )
                        .slice(0, 4)
                }
                renderItem={(item) => (
                  <Link
                    to={
                      item?.type
                        ? "/search-lead"
                        : `/lead-details/${item?.clientLeadId}?type=email`
                    }
                  >
                    <List.Item
                      className="notification-item"
                      actions={[
                        <X
                          key="close"
                          className="tw-w-4 tw-h-4 tw-cursor-pointer hover:tw-text-rose-500"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            if (item?.type) {
                              dispatch(readNotification(item.id));
                            } else {
                              dispatch(markAsRead(item.clientLeadId));
                            }
                          }}
                        />,
                      ]}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            className="notification-avatar"
                            icon={
                              item?.type === "LEAD_TRANSFER" ? (
                                <ArrowLeftRight className="tw-w-4 tw-h-4" />
                              ) : (
                                <Mail className="tw-w-4 tw-h-4" />
                              )
                            }
                          />
                        }
                        title={
                          <Typography.Text strong>
                            {item?.type ? (
                              <>{item?.message}</>
                            ) : (
                              <>
                                {item?.subject?.includes("Re")
                                  ? getRandomReplyMessage(item.leadName)
                                  : getRandomEmailMessage(item.leadName)}
                              </>
                            )}
                          </Typography.Text>
                        }
                        description={
                          <div className="notification-time">
                            {formatMessageTime(item.createdDate)}
                          </div>
                        }
                      />
                    </List.Item>
                  </Link>
                )}
              />
              {unreadNotifications.length > 4 && (
                <div
                  className="notification-footer"
                  onClick={() => setViewAll(!viewAll)}
                >
                  {viewAll ? "View Less" : "View All"}
                </div>
              )}
            </>
          ) : (
            <div className="notification-empty">
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No notifications"
              />
            </div>
          )}
        </div>
      )}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Badge
        count={unreadNotifications?.length + notifications?.length}
        size="small"
        offset={[-2, 2]}
      >
        <Tooltip title="Notifications">
          <Bell
            className={`tw-p-1.5 tw-w-8 tw-h-8 tw-cursor-pointer tw-text-[#65686F] tw-bg-[#F4F4F4] tw-rounded-full hover:tw-text-[#5D44FF] tw-transition-colors`}
          />
        </Tooltip>
      </Badge>
    </Dropdown>
  );
};

export default NotificationDropdown;
